import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[farrisTemplate]'
})
export class FarrisTemplateDirective {

    @Input() type: string;
    @Input('farrisTemplate') name: string;

    constructor(public template: TemplateRef<any>) {}

    getType(): string {
        return this.name;
    }
}

